<template>
<layout-crumb :opts="[{label: task.siteName}, {label: $route.meta.label}]">
  <section class="selector-wrapper">
    <section class="selector-body">
      <van-cell-group v-if="maintainOrgList.length > 0">
        <van-swipe-cell
          v-for="(maintainOrg, index) in maintainOrgList"
          :key="index"
        >
          <van-cell
            :title="maintainOrg"
            is-link
            @click="onEditItemClick(maintainOrg)"
          />
          <template #right>
            <van-button square type="danger" text="删除" @click="onDelBtnClick(index, maintainOrg)" />
          </template>
        </van-swipe-cell>
      </van-cell-group>
      <van-empty v-else>
        <p class="van-empty__description" style="margin-top:-24px;">
          本次任务还未添加运维组织, 请点击下方的<span style="color:#FE7300;" @click="onCreateBtnClick">添加运维组织</span>按钮
        </p>
      </van-empty>
    </section>

    <section class="selector-footer">
      <button class="back-btn" @click="onPreStepClick">返回站房信息</button>
      <Abort />
      <button class="create-btn" @click="onCreateBtnClick">添加运维组织</button>
      <button class="next-btn" @click="onNextStepClick">下一步</button>
    </section>
  </section>

  <van-popup
    v-model="editorVisible"
    position="bottom"
    round
    closeable
  >
    <div style="font-size:16px;line-height:44px;padding:0 16px;">添加运维组织</div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="maintainOrg"
        name="运维组织"
        label="运维组织"
        placeholder="运维组织名称"
        :rules="[{required:true,message:'请填写运维组织'}]"
      />

      <div style="margin:16px;">
        <van-button round block type="info" native-type="submit">确定</van-button>
      </div>
    </van-form>
  </van-popup>

  <van-overlay :show="overlayVisible">
    <van-loading type="spinner" />
  </van-overlay>
</layout-crumb>
</template>

<script>
import {mapGetters} from 'vuex'
import {Dialog} from 'vant'

export default {
  name: 'index',
  routeInfo: {
    label: '运维组织'
  },
  data () {
    return {
      editorVisible: false,
      overlayVisible: false,
      maintainOrg: ''
    }
  },
  computed: {
    ...mapGetters({
      task: 'Task/task',
      maintainOrgs: 'Task/maintainOrgs',
      maintainOrgList: 'Task/maintainOrgList',
      taskNum: 'Task/taskNum'
    })
  },
  methods: {
    onPreStepClick () {
      this.save(() => this.$router.replace({
        name: 'SiteInfo'
      }))
    },
    onCreateBtnClick () {
      this.maintainOrg = ''
      this.operatorType = 1
      this.editorVisible = true
    },
    onNextStepClick () {
      this.save(() => this.$router.replace({
        name: 'DeviceSelector'
      }))
    },
    onEditItemClick (maintainOrg) {
      this.maintainOrg = maintainOrg
      this.operatorType = 2
      this.maintainOrgIndex = this.maintainOrgList.indexOf(maintainOrg)
      this.editorVisible = true
    },
    onDelBtnClick (index, maintainOrg) {
      this.maintainOrgList.splice(index, 1)
    },
    onSubmit () {
      let {maintainOrg, operatorType, maintainOrgList} = this
      maintainOrg = maintainOrg.trim()
      let index = maintainOrgList.indexOf(maintainOrg)

      switch (operatorType) {
        case 1:
          if (index > -1) {
            Dialog.alert({
              message: '已存在相同的运维组织名称'
            }).then(() => {})
          } else {
            maintainOrgList.push(maintainOrg)
            this.editorVisible = false
          }
          break
        case 2:
          let editIndex = this.maintainOrgIndex
          if (index > -1 && index !== editIndex) {
            Dialog.alert({
              message: '已存在相同的运维组织名称'
            }).then(() => {})
          } else {
            maintainOrgList.splice(editIndex, 1, maintainOrg)
            this.editorVisible = false
          }
          break
      }
    },
    save (callback) {
      let maintainOrgList = this.maintainOrgList
      let maintainOrgs = maintainOrgList.join('/').replace(/\s+/g, '')

      if (maintainOrgs !== this.maintainOrgs) {
        this.overlayVisible = true

        this.$api.Task.saveMaintainOrgs({
          id: this.task.id,
          maintainOrgs
        }).then(() => {
          this.setMaintainOrgs(maintainOrgs)
          callback && callback()
        }).catch(console.error).finally(() => {
          this.overlayVisible = false
        })
      } else {
        callback()
      }
    },
    setMaintainOrgs (maintainOrgs) {
      this.$store.commit('Task/setMaintainOrgs', maintainOrgs)
    }
  }
}
</script>

<style lang="scss" scoped>
.selector-wrapper {
  .selector-body {
    padding: 1rem;
    border-bottom: 1px solid #cfd0d3;
    background-color: #f7f8fa;
  }
}

.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/03MaintainOrgSelector/index.vue